<rt-wysiwyg-inline-button
  [clipboardValue]="state.url!"
  [displayValue]="texts.label || texts.linkName!"
  [class.expired]="state.expired || state.noTokenWarning"
  [rtTooltip]="state.expired ? ('app.wysiwyg.link.expired_tooltip' | translate) : undefined"
  #followDropdownTrigger="rtOverlayOrigin"
  variant="simple small-x"
  (click)="followDropdown.open = true"
  rt-overlay-origin
  [dropdownOpen]="followDropdown.open"
  [icon]="icons[state.type!]!"
/>

<ng-template
  #followDropdown="rtConnectedOverlay"
  [positions]="dropdownPositions"
  [origin]="followDropdownTrigger"
  [open]="dropdownOpened"
  (backdropClick)="followDropdown.open = false"
  rt-connected-overlay
  hasBackdrop
>
  <rt-dropdown>
    <rt-dropdown-item [hasHoverEffect]="false" (click)="$event.stopPropagation()">
      <div class="heading">{{ texts.dropdownTitle }}</div>
      <div class="subheading">{{ state.name || texts.linkName }}</div>
    </rt-dropdown-item>

    @if (!noEdit) {
      <rt-dropdown-item (click)="edit(state)">
        <rt-icon prefix name="edit" />
        {{ 'app.wysiwyg.link.edit_link' | translate }}
      </rt-dropdown-item>
    }

    @if (texts.isValidLink) {
      <rt-dropdown-item [href]="state.url!" hrefTarget="_blank">
        <rt-icon prefix name="open-in-new" />
        {{ 'app.common.preview' | translate }}
      </rt-dropdown-item>
    }

    <rt-dropdown-item (click)="remove(state)">
      <rt-icon prefix name="remove-circle" />
      {{ 'app.wysiwyg.dialog.remove_link' | translate }}
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
